export default __webpack_public_path__ + "static/myhub-comp-mobile-2f6304e371eb8c0084db57c6ae1d2390.png";